export enum ReportTypes {
  TRADING_REPORT = "trading_report",
}
